import { useTranslation } from 'react-i18next';
import Spinner from '../../ui/Spinner';

/** Shown in place of a booking form while the AI reads the attached document. */
export function ExtractingPlaceholder() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16">
      <Spinner size="lg" />
      <p className="text-sm font-medium text-slate-600 dark:text-slate-300">{t('bookings.form.extracting')}</p>
    </div>
  );
}
